<template>


    <div>
        <div v-if="is_super_admin">
            
            <div style="padding: 0px 16px;">
    
                <el-button type="primary" @click="exportAllFunc()" size="small" icon="el-icon-download" style="float:right; margin-left:10px;">导出所有</el-button>
                <el-button type="primary" @click="exportAllfinishedFunc()" size="small" icon="el-icon-download" style="float:right;">导出已完成工单</el-button>
                <el-button type="primary" @click="exportAllUnfinishedFunc()" size="small" icon="el-icon-download" style="float:right;">导出未完成工单</el-button>
            </div>

            <div style="padding: 10px 16px;">
                <el-table
                    id="unit"
                    :data="lWorkOrderList"
                    style="width: 100%;border-color:'#606266'"
                    :default-sort = "{prop: 'date', order: 'descending'}"
                    :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
                    :cell-style="{color: '#666',fontSize:'14px'}"
                    border
                    >
                    <el-table-column
                        fixed
                        align="center"
                        prop="work_order_id"
                        label="工单ID"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="shop_name"
                        label="店铺"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="room_name"
                        label="包间"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="work_order_type"
                        label="工单类型"
                        sortable
                        >
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.work_order_type == 1">到扫工单</el-tag>
                            <el-tag v-else-if="scope.row.work_order_type == 2">维修工单</el-tag>
                            <el-tag v-else-if="scope.row.work_order_type == 3">更改玩法工单</el-tag>
                            <el-tag v-else>错误的类型</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="work_order_status"
                        label="工单状态"
                        sortable
                        >
                        <template slot-scope="scope">
                            <el-tag type="success" v-if="scope.row.work_order_status == 0">完成</el-tag>
                            <el-tag type="danger" v-else>进行中</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="work_order_dispatch_user"
                        label="工单创建人"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="work_order_create_time"
                        label="工单创建时间"
                        sortable
                        >
                    </el-table-column>


                    <el-table-column
                        fixed
                        align="center"
                        prop="work_order_end_time"
                        label="工单结束时间"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="work_order_deal_user"
                        label="工单处理人"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="work_order_start_time"
                        label="到店打卡时间"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column
                        fixed
                        align="center"
                        prop="work_order_finish_time"
                        label="离店打卡时间"
                        sortable
                        >
                    </el-table-column>

                    <el-table-column
                        align="center"
                        label="操作"
                        width="260px"
                    >
                        <template slot-scope="scope">
                            <el-button round plain icon="el-icon-search" type="success" size="small" @click="showFunc(scope.row)">查看详情</el-button>
                            <el-button round icon="el-icon-delete" type="danger" size="small" @click="deleteFunc(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>

                </el-table>

                <el-pagination
                    @current-change="changeCurrent"
                    :current-page="iCurrentPage"
                    :page-size="10"
                    layout="total, prev, pager, next, jumper"
                    :total="iMaxTotal"
                    style="text-align:right; margin-top:15px"
                    >
                </el-pagination>

                <el-drawer
                    :title="drawerTtitle"
                    :visible.sync="isShowDrawer"
                    :direction="direction">
                    
                    <div v-if="iWorkOrderType==1">
                        <div>
                            <el-timeline :v-mode="dWorkOrderInfo">
                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_one" placement="top" :color="dWorkOrderInfo.web_status_color_one" >
                                    <el-card>
                                        <h4>打扫工单派遣时间</h4>
                                        <p>{{ dWorkOrderInfo.work_order_dispatch_user }} 提交于 {{ dWorkOrderInfo.work_order_create_time }}</p>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_two" placement="top" :color="dWorkOrderInfo.web_status_color_two" >
                                    <el-card>
                                        <h4>到店打卡</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_two }}</p>
                                        <p>打卡经纬度: {{ dWorkOrderInfo.work_order_arrive_latitude }}</p>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_three" placement="top" :color="dWorkOrderInfo.web_status_color_three" >
                                    <el-card>
                                        <h4>打扫前拍照</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_three }}</p>
                                        <el-image 
                                        v-for='url in dWorkOrderInfo.img_list_three' :key="url.key"
                                        style="width: 100px; height: 100px"
                                        :src="url" 
                                        :preview-src-list="dWorkOrderInfo.img_list_three">
                                        </el-image>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_four" placement="top" :color="dWorkOrderInfo.web_status_color_four" >
                                    <el-card>
                                        <h4>打扫后拍照</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_four }}</p>
                                        <el-image 
                                        v-for='url in dWorkOrderInfo.img_list_four' :key="url.key"
                                        style="width: 100px; height: 100px"
                                        :src="url" 
                                        :preview-src-list="dWorkOrderInfo.img_list_four">
                                        </el-image>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_five" placement="top" :color="dWorkOrderInfo.web_status_color_five" >
                                    <el-card>
                                        <h4>确认设备正常拍照</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_five }}</p>
                                        <el-image 
                                        v-for='url in dWorkOrderInfo.img_list_five' :key="url.key"
                                        style="width: 100px; height: 100px"
                                        :src="url" 
                                        :preview-src-list="dWorkOrderInfo.img_list_five">
                                        </el-image>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_six" placement="top" :color="dWorkOrderInfo.web_status_color_six" >
                                    <el-card>
                                        <h4>离店打卡</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_six }}</p>
                                        <p>打卡经纬度: {{ dWorkOrderInfo.work_order_leave_latitude }}</p>
                                    </el-card>
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                    </div>

                    <div v-else-if="iWorkOrderType==2">
                        <div>
                            <el-timeline :v-mode="dWorkOrderInfo">
                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_one" placement="top" :color="dWorkOrderInfo.web_status_color_one" >
                                    <el-card>
                                        <h4>维修工单派遣时间</h4>
                                        <p>{{ dWorkOrderInfo.work_order_dispatch_user }} 提交于 {{ dWorkOrderInfo.work_order_create_time }}</p>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_two" placement="top" :color="dWorkOrderInfo.web_status_color_two" >
                                    <el-card>
                                        <h4>到店打卡</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_two }}</p>
                                        <p>打卡经纬度: {{ dWorkOrderInfo.work_order_arrive_latitude }}</p>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_three" placement="top" :color="dWorkOrderInfo.web_status_color_three" >
                                    <el-card>
                                        <h4>问题确认</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_three }}</p>
                                        <p>{{ dWorkOrderInfo.work_order_reason }}</p>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_four" placement="top" :color="dWorkOrderInfo.web_status_color_four" >
                                    <el-card>
                                        <h4>维修前拍照</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_four }}</p>
                                        <el-image 
                                        v-for='url in dWorkOrderInfo.img_list_four' :key="url.key"
                                        style="width: 100px; height: 100px"
                                        :src="url" 
                                        :preview-src-list="dWorkOrderInfo.img_list_four">
                                        </el-image>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_five" placement="top" :color="dWorkOrderInfo.web_status_color_five" >
                                    <el-card>
                                        <h4>维修后拍照</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_five }}</p>
                                        <el-image 
                                        v-for='url in dWorkOrderInfo.img_list_five' :key="url.key"
                                        style="width: 100px; height: 100px"
                                        :src="url" 
                                        :preview-src-list="dWorkOrderInfo.img_list_five">
                                        </el-image>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_six" placement="top" :color="dWorkOrderInfo.web_status_color_six" >
                                    <el-card>
                                        <h4>离店打卡</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_six }}</p>
                                        <p>打卡经纬度: {{ dWorkOrderInfo.work_order_leave_latitude }}</p>
                                    </el-card>
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                    </div>

                    <div v-else-if="iWorkOrderType==3">
                        <div>
                            <el-timeline :v-mode="dWorkOrderInfo">
                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_one" placement="top" :color="dWorkOrderInfo.web_status_color_one" >
                                    <el-card>
                                        <h4>更改玩法工单派遣时间</h4>
                                        <p>{{ dWorkOrderInfo.work_order_dispatch_user }} 提交于 {{ dWorkOrderInfo.work_order_create_time }}</p>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_two" placement="top" :color="dWorkOrderInfo.web_status_color_two" >
                                    <el-card>
                                        <h4>到店打卡</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_two }}</p>
                                        <p>打卡经纬度: {{ dWorkOrderInfo.work_order_arrive_latitude }}</p>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_three" placement="top" :color="dWorkOrderInfo.web_status_color_three" >
                                    <el-card>
                                        <h4>更改玩法前拍照</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_three }}</p>
                                        <el-image 
                                        v-for='url in dWorkOrderInfo.img_list_three' :key="url.key"
                                        style="width: 100px; height: 100px"
                                        :src="url" 
                                        :preview-src-list="dWorkOrderInfo.img_list_three">
                                        </el-image>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_four" placement="top" :color="dWorkOrderInfo.web_status_color_four" >
                                    <el-card>
                                        <h4>更改玩法后拍照</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_four }}</p>
                                        <el-image 
                                        v-for='url in dWorkOrderInfo.img_list_four' :key="url.key"
                                        style="width: 100px; height: 100px"
                                        :src="url" 
                                        :preview-src-list="dWorkOrderInfo.img_list_four">
                                        </el-image>
                                    </el-card>
                                </el-timeline-item>

                                <el-timeline-item :timestamp="dWorkOrderInfo.web_status_timestamp_five" placement="top" :color="dWorkOrderInfo.web_status_color_five" >
                                    <el-card>
                                        <h4>离店打卡</h4>
                                        <p>{{ dWorkOrderInfo.work_order_deal_user }} 提交于 {{ dWorkOrderInfo.status_time_five }}</p>
                                        <p>打卡经纬度: {{ dWorkOrderInfo.work_order_leave_latitude }}</p>
                                    </el-card>
                                </el-timeline-item>

                            </el-timeline>
                        </div>
                    </div>
                    
                    <div v-else>
                    <p>错误工单</p>
                    </div>
                </el-drawer>
            </div>
        </div>

        <div v-else>
            <div style="text-align: center;">
                <div style="margin-top: 0px;">
                <img src="../assets/permission_denied.png">
                <div style="margin-top: 20px;">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
                </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
export default {
    name: "WorkOrderSystem",
    
    data(){
        return {
            iCurrentPage: 1,
            iMaxTotal: 10,
            lWorkOrderList: [],

            // 派遣详情
            isShowDrawer: false,
            direction: 'rtl',
            drawerTtitle: '工单详情',
            // 订单类型
            iWorkOrderType: 1,
            // 订单信息
            dWorkOrderInfo: {},
            is_super_admin: false,

        }
    },

    mounted(){
        // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
        let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
        if (isSuperAdmin == "false") {
            this.is_super_admin = false
            return
        } else {
            this.is_super_admin = true
        }
        this.getWorkOrderList()
    },

    methods: {
        // 获取工单列表
        async getWorkOrderList(){
            let url = '/api/work_order/'
            let params = {
                'page': this.iCurrentPage,
                'page_size': 10,
            }
            let res = await this.$axios.get(url, {params: params})
            console.log(res)
            this.lWorkOrderList = res.data.results
            this.iMaxTotal = res.data.count
        },

        // 分页事件
        changeCurrent(val){
            this.iCurrentPage = val;
            this.getWorkOrderList();
        },

        // 查看详情
        showFunc(row){
            this.isShowDrawer = true
            this.dWorkOrderInfo = row
            this.iWorkOrderType = row.work_order_type
            // this.
            
        },

        // 删除事件
        deleteFunc(row){
            var _this = this
            this.$confirm('此操作将永久删除该工单信息', '删除消息警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                _this.$axios.delete('/api/work_order/' + row.work_order_id + '/').then(
                function(res){_this.$message({type: 'success', message: '删除成功!'});
                _this.getWorkOrderList()})
            }).catch(() => {
                _this.$message({type: 'info',message: '已取消删除'});          
            });
        },

        // 导出数据
        async exportAllFunc(){
            // 请求数据
            await this.$axios.get('/api/work_order/').then(
                function(res){
                    console.log(res.data)
                    // 将请求到数据转换为数组数据
                    var data = res.data
                    var arrData = typeof data != 'object' ? JSON.parse(data) : data
                    console.log(arrData)
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(arrData);
                    XLSX.utils.book_append_sheet(wb, ws, '工单列表');
                    var wbout = XLSX.write(wb, {bookType:'xlsx', type:'binary'});
                    function s2ab(s) {
                        var buf = new ArrayBuffer(s.length);
                        var view = new Uint8Array(buf);
                        for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
                        return buf;
                    }
                    FileSaver.saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), "工单数据.xlsx");
                }
            )
        },

        // 导出所有已完成的工单
        async exportAllfinishedFunc(){
            // 请求数据
            await this.$axios.get('/api/work_order/', {params: {"status_filter": 0}}).then(
                function(res){
                    console.log(res.data)
                    // 将请求到数据转换为数组数据
                    var data = res.data
                    var arrData = typeof data != 'object' ? JSON.parse(data) : data
                    console.log(arrData)
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(arrData);
                    XLSX.utils.book_append_sheet(wb, ws, '工单列表');
                    var wbout = XLSX.write(wb, {bookType:'xlsx', type:'binary'});
                    function s2ab(s) {
                        var buf = new ArrayBuffer(s.length);
                        var view = new Uint8Array(buf);
                        for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
                        return buf;
                    }
                    FileSaver.saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), "工单数据(已完成).xlsx");
                }
            )
        },

        // 导出所有未完成工单
        async exportAllUnfinishedFunc(){
            // 请求数据
            await this.$axios.get('/api/work_order/', {params: {"work_order_status": 0}}).then(
                function(res){
                    console.log(res.data)
                    // 将请求到数据转换为数组数据
                    var data = res.data
                    var arrData = typeof data != 'object' ? JSON.parse(data) : data
                    console.log(arrData)
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(arrData);
                    XLSX.utils.book_append_sheet(wb, ws, '工单列表');
                    var wbout = XLSX.write(wb, {bookType:'xlsx', type:'binary'});
                    function s2ab(s) {
                        var buf = new ArrayBuffer(s.length);
                        var view = new Uint8Array(buf);
                        for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
                        return buf;
                    }
                    FileSaver.saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), "工单数据(未完成).xlsx");
                }
            )
        },

    },
}
</script>